import { render, staticRenderFns } from "./adv_media_link_list.vue?vue&type=template&id=52495a17&scoped=true&"
import script from "./adv_media_link_list.vue?vue&type=script&lang=js&"
export * from "./adv_media_link_list.vue?vue&type=script&lang=js&"
import style0 from "./adv_media_link_list.vue?vue&type=style&index=0&id=52495a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52495a17",
  null
  
)

export default component.exports